import { useTranslation } from 'next-i18next'

import Navipay from '@/components/icons/Navipay'
import AppleButton from '@/components/common/AppleButton'
import GoogleButton from '@/components/common/GoogleButton'

import { Container, IconsWrapper, IconWrapper, Title } from './AppLinks.styled'

function AppLinks() {
  const { t } = useTranslation('common')
  return (
    <Container>
      <Title as="strong">{t('navipayApp')}</Title>
      <IconWrapper>
        <Navipay />
      </IconWrapper>
      <IconsWrapper>
        <GoogleButton />
        <AppleButton />
      </IconsWrapper>
    </Container>
  )
}

export default AppLinks
